import { useOnFirstRender } from '@sp/util/helpers';
import { useEffect } from 'react';
import { NAVIGATE_BACK_MODEL } from './navigate-back-model';

export function useSetPreviousUrl(url: string) {
  useOnFirstRender(() => NAVIGATE_BACK_MODEL.previousUrlSet(url));
  useEffect(() => NAVIGATE_BACK_MODEL.previousUrlReset, []);
}
